export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const validateEmailRegex = (inputText) => {
  var mailFormat =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (inputText.value.match(mailFormat)) {
    return true
  } else {
    return false
  }
}

export const getTrackingId = () => {
  if (hoian && typeof hoian.getTrackingId === 'function') return hoian.getTrackingId()
  console.warn('did not receive hoian instance...')
  return false
}

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const getCouponTitle = (text, couponTitle) => {
  if (!text) return ''
  return text.replace(/\{\{coupon_title\}\}/g, couponTitle)
}

export const setTimeOnSite = async (timeOnSite, node_uuid) => {
  return await new Promise((resolve) => {
    const interval = setInterval(() => {
      const getCountOnSite = parseInt(sessionStorage.getItem(`timeLogPage`))

      if (Date.now() > getCountOnSite + timeOnSite * 1000) {
        clearInterval(interval)
        resolve(true)
      }
    }, 1000)
  })
}

export const checkProductPage = () => {
  let count = parseInt(sessionStorage.getItem(`countViewProductsPage`))
  if (count > 0) {
    return true
  }
  return false
}

export const setTimeOutProductPage = async (time, products, node_uuid) => {
  return await new Promise((resolve) => {
    const interval = setInterval(() => {
      const getTimeLogPageProduct = parseInt(sessionStorage.getItem(`timeLogPageProduct`))
      const get2Products = parseInt(sessionStorage.getItem(`countViewProductsPage`))

      // var today = new Date()
      // var timeNow = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()

      // console.log('time =>>>> ', timeNow)
      // console.log('Date.now() ', Date.now())
      // console.log('getTimeLogPageProduct ', getTimeLogPageProduct + time * 1000)

      if (Date.now() < getTimeLogPageProduct + time * 1000) {
        // console.log('time <==== ')
        if (get2Products >= products) {
          // console.log('product >==== 2 ')
          if (checkDuplicateProducts(products)) {
            clearInterval(interval)
            resolve(true)
          }
        }
      } else {
        // console.log('time >==== timeNow ')
        clearInterval(interval)
        resolve(false)
      }
    }, 1000)
  })
}

export const checkDuplicateProducts = (products) => {
  const getProductsView = sessionStorage.getItem(`productsView`)
  if (getProductsView) {
    const getProductsViewArr = getProductsView.split(',')
    // console.log(getProductsViewArr)

    const getProductsViewArrUnique = [...new Set(getProductsViewArr)]
    if (getProductsViewArrUnique.length >= products) {
      return true
    }
    return false
  }
  return false
}
